import type { FunctionComponent } from "react";
import { ExportCampaignMetricsModalPartial } from "../../../../partials/admin/menus/campaign/export-campaign-metrics-modal.admin.partials";

export const ExportCampaignMetricsModalAdminScreen: FunctionComponent = () => {
	return <ExportCampaignMetricsModalPartial />;
};
